<template>
  <div>
    <nav-header></nav-header>
    <div class="in-system-page addcompany-form validate-form p-l-50 p-r-50 p-t-10 p-b-150">
      <section>
        <div class="page-title">
            <h2>Editar Projeto</h2>
        </div>
        <hr />
        <br />
        <div class="wrap-form-fields" style="align: center; overflow: visible">
          <div class="input-container">
            <label class="label-input">Nome:</label>
            <input
              v-model="name"
              type="name"
              id="inputName"
              placeholder="Nome"
              class="input-field"
            />
          </div>
          <br />
          <div class="input-container-dropdown">
            <dropdown-taps
              :options="categories"
              :updateSelection="validateSelectionCat"
              :initial="category"
              messageButton="Categorias"
              messageRemoveData="Remover todas as categorias"
              messageLabelSearch="Pesquisa de categorias"
              messageMissingDataSearch="Nenhuma categoria corresponde a sua pesquisa"
              messageMissingData="Nenhuma categoria disponível"
              messageExtra="Consultar resultado dos documentos"
              :extraFunc="consultDocs"
            />
          </div>
          <div class="input-container">
            <b-form-checkbox
              v-model="digSign"
              value="S"
              unchecked-value="N"
              style="z-index: 0"
            > Desejo assinar digitalmente os documentos obtidos por esse projeto
            </b-form-checkbox>
          </div>
          <br>
          <b-form-checkbox v-model="restIp" name="check-button" switch>
            Restringir acesso por IP fixo
          </b-form-checkbox>
          <b-collapse id="collapse-ip" :visible="restIp">
            <div class="input-container">
              <!-- <label class="label-input">Restringir o acesso por IP fixo:</label> -->
              <form-tags
                :updateTags="updateIps"
                :initial="fixedIps"
                :placeholder="'Insira aqui um endereço de IPv4 ou IPv6 válido'"
              ></form-tags>
            </div>
            <br>
          </b-collapse>
          <b-form-checkbox v-model="restQt" name="check-button" switch>
            Restringir quantidade de requisições mensais
          </b-form-checkbox>
          <b-collapse :visible="restQt">
            <div class="input-container">
              <input class="input-field" v-model="reqQt" placeholder="Quantidade de requisições" type="number">
            </div>
            <br>
          </b-collapse>
          <b-form-checkbox v-model="restTp" name="check-button" switch>
            Restringir intervalo de tempo entre requisições em segundos
          </b-form-checkbox>
          <b-collapse :visible="restTp">
            <div class="input-container">
              <input class="input-field" v-model="reqTp" placeholder="Intervalo entre requisições" type="number">
            </div>
            <br>
          </b-collapse>
        </div>
        <br />
        <button
          class="btn btn-secondary"
          v-on:click="$router.push({ name: 'projectManagement' })"
          style="aling: left; margin-left: 10px"
        >
          Cancelar
        </button>
        <button
          class="btn btn-primary"
          v-on:click="this.updateProject"
          style="aling: left"
        >
          Confirmar
        </button>

        <div style="aling: left">
          <b-modal id="modal-1" class="text-center">
            <template #modal-header>
              <div class="mx-auto text-center">
                <h3>Consultar quantidade de documentos por categorias</h3>
              </div>
            </template>
            <b-row>
              <b-col style="margin-left: 5px">
                Data Início:
              </b-col>
              <b-col style="margin-left: -20px">
                Data Final:
              </b-col>
            </b-row>
            <b-row>
            <month-picker-input
              style="z-index: 3;
              margin-left: 20px;
              margin-bottom: 15px;"
              v-model="dateStart"
              :no-default="true"
              lang="pt"/>
            <month-picker-input
              style="z-index: 3; margin-left: 40px;"
              v-model="dateEnd"
              :no-default="true"
              lang="pt"/>
            </b-row>
            <b-input-group 
              class="input-container"
              style="padding-left: 20px; padding-right: 28px"
              >
              <b-form-input
                v-model="modalText"
                type="text"
                id="inputText"
                placeholder="Texto"
                class="input-field"
                autocomplete="off"
              />
              <b-input-group-append>
                <button
                  class="btn btn-primary"
                  v-on:click="this.countDocs"
                >Consultar</button>
              </b-input-group-append>
            </b-input-group>
            <br />
            <div v-if="!isLoading && showDocs">
              <p><strong>Número de documentos:</strong> {{ docsCount }}</p>
              <p><strong>Custo estimado:</strong> R${{ formatMoney(docsValue) }}<span style="color: darkgray">{{ digSign=='S'?' (com assinatura digital)':''}}</span></p>
            </div>
            <div v-else class="text-center mt-2">
              <b-spinner v-show="isLoading" label="Spinning"></b-spinner>
            </div>
            <template #modal-footer="{ ok, cancel }">
              <b-button class="btn-primary" @click="ok()">Confirmar</b-button>
              <b-button class="primary" @click="cancel()">Cancelar</b-button>
            </template>
          </b-modal>
        </div>
      </section>
    </div>
    <user-profile-footer></user-profile-footer>
    <b-modal id="model-apikey" centered hide-footer @hidden="this.onHidden"> 
      <template #modal-title> Chave API </template>
      <div class="d-block">
        <h5>Utilize essa chave para fazer requisições na API</h5>
        <div class="text-center">
          <code>{{ apikey }}</code>
          <input type="hidden" ref="apikey" :value="apikey" />
        </div>
      </div>
      <button id="btn-copy" class="btn btn-primary" block @click="this.copyKey">
        Copiar
      </button>
    </b-modal>
  </div>
</template>

<style scoped src="@/assets/css/util.css"></style>

<style scoped>
.btn {
  margin-top: 0px;
}

.wrap-form-fields {
  width: 720px;
}
</style>

<style scoped>
.dropdown {
  width: 100%;
  min-width: 500px;
}
.dropdown-input {
  width: 100%;
}
.text-center {
  margin: 20px 0;
}
code {
  font-size: 2em;
}
#btn-copy {
  width: 100%;
}
.badge {
  margin: 1px;
}
.badge-container {
  vertical-align: initial;
}
#modal-1 {
  overflow-y: scroll;
}
</style>

<script>
import axios from "axios";
import config from "../helpers/generalConfig";
import NavHeader from "../components/NavHeader.vue";
import UserProfileFooter from "../components/UserProfileFooter.vue";
import DropdownTaps from "../components/DropdownTags.vue";
import FormTags from "../components/FormTags.vue";
import { mask } from "vue-the-mask";
import { MonthPickerInput } from 'vue-month-picker';

export default {
  components: { NavHeader, UserProfileFooter, DropdownTaps, MonthPickerInput, FormTags },

  directives: { mask },

  created() {
    this.getProject();
    this.getCategories();
  },
  
  data() {
    return {
      name: "",
      apikey: "",
      id_project: this.$route.params.id,
      categories: [],
      category: [],
      modalText: '',
      docsCount: 0,
      docsValue: 0,
      isLoading: false,
      showDocs: false,
      dateStart: null,
      dateEnd: null,
      digSign: 'N',
      fixedIps: [],
      restIp: false,
      reqQt: '',
      restQt: false,
      reqTp: '',
      restTp: false,
    };
  },

  methods: {
    countDocs() {
      if (!this.dateStart) {
        this.$bvToast.toast('Selecione a data inicial', {
          title: 'Erro na consulta',
          variant: 'danger',
          solid: true
        });
        return;
      }
      if (!this.dateEnd) {
        this.$bvToast.toast('Selecione a data final', {
          title: 'Erro na consulta',
          variant: 'danger',
          solid: true
        });
        return;
      }
      if (!this.modalText) {
        this.$bvToast.toast('Selecione o texto a ser buscado', {
          title: 'Erro na consulta',
          variant: 'danger',
          solid: true
        });
        return;
      }
      this.isLoading = true;
      const company = this.company || this.$store.getters['auth/user'].CompanyId;
      axios
        .post(
          `${config.jsonServer}/api/docsCount`,
          {
            texto: this.modalText,
            categorias: this.category,
            dataInicio: this.dateStart.from,
            dataFim: this.dateEnd.to,
            empresa: company,
            assinaturaDigital: this.digSign === 'S'
          },
          this.headers()
        )
        .then((res) => {
          this.docsCount = res.data['hits'];
          this.docsValue = res.data['custo_estimado_requisicao'];
          this.isLoading = false;
          this.showDocs = true;
        })
        .catch((err) => {
          if (err.response) {
            this.$bvToast.toast(err.response.data.message, {
              title: "Erro nas categorias",
              variant: "danger",
              solid: true,
            });
            this.isLoading = false;
          }
        });
    },
    updateProject() {
      if (!this.name) {
        this.$bvToast.toast("Informe um nome válido.", {
          title: "Nome inválido",
          variant: "danger",
          solid: true,
        });
        return;
      }
      if(!this.category.length) {
        this.$bvToast.toast("Selecione ao menos uma categoria", {
          title: "Categoria não selecionada",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const body = {
        id_projeto: this.id_project || "",
        nome_projeto: this.name,
        categorias: this.category,
        arquivo_assinado: this.digSign,
      }

      if (this.restIp) body.ips_fixos = this.fixedIps.join(',');

      if (this.restQt) body.restricao_quantidade = this.reqQt;

      if (this.restTp) body.restricao_tempo = this.reqTp;

      axios
        .put(
          `${config.jsonServer}/project/categories`,
          body, this.headers()
        )
        .then((res) => {
          this.$bvToast.toast("Edição realizada com sucesso.", {
            title: "Edição realizada",
            variant: "success",
            solid: true,
          });
          this.apikey = res.data.chave_api;
          this.$bvModal.show("model-apikey");
        })
        .catch((err) => {
          if (err.response) {
            this.$bvToast.toast(err.response.data.message, {
              title: "Erro ao editar",
              variant: "danger",
              solid: true,
            });
          }
          })
    },

    getProject() {
      axios.get(`${config.jsonServer}/project/search?id_projeto=${this.id_project}`, this.headers())
      .then((projs) => {
        this.name = projs.data[0].nome_projeto;
        this.category = projs.data[0].categorias.map(c => c.nome_categoria);
        this.digSign = projs.data[0].arquivo_assinado;
        if (typeof projs.data[0].ips_fixos === 'string') {
          this.fixedIps = projs.data[0].ips_fixos.replace('undefined', '')
            .replace('[', '').replace(']','').split(',').filter(i => i);
          if(this.fixedIps.length) this.restIp = true;
        }
        this.reqQt = projs.data[0].restricao_quantidade || '';
        if(this.reqQt) this.restQt = true;
        this.reqTp = projs.data[0].restricao_tempo || '';
        if(this.reqTp) this.restTp = true;
      }).catch(err => {
        if(err){
          if(err.response){
            this.$bvToast.toast(err.response.data.message, {
              title: "Erro ao carregar projeto",
              variant: "danger",
              solid: true,
            });
          } else {
            this.$bvToast.toast('Sem resposta do servidor', {
              title: "Erro ao carregar projeto",
              variant: "danger",
              solid: true,
            });
          }
        }
      })
    },

    getCategories() {
      axios
        .get(`${config.jsonServer}/category/noparent`, this.headers())
        .then((cats) => {
          this.categories = cats.data.map((c) => {
            return {
              id: c.id_categoria,
              name: c.nome_categoria,
            };
          });
        });
    },

    headers() {
      const token = this.$store.getters["auth/token"].token;
      return { headers: { Authorization: "Bearer " + token } };
    },

    companyId() {
      return this.$store.getters["auth/user"].CompanyId;
    },

    isAdminCEPE() {
      return this.$store.getters["auth/user"].Role === "ADMIN_CEPE";
    },

    validateSelection(selected) {
      if ("id" in selected) this.company = selected.id;
    },

    validateSelectionCat(selected) {
      this.category = selected;
    },

    copyKey() {
      const inpAPI = this.$refs["apikey"];
      inpAPI.setAttribute("type", "text");
      inpAPI.select();
      const copied = document.execCommand("copy");
      if (copied) {
        this.$bvToast.toast("Copiado com sucesso", {
          title: "Chave API copiada",
          variant: "success",
          solid: true,
        });
      } else {
        this.$bvToast.toast("Erro ao copiar", {
          title: "Chave API não copiada",
          variant: "danger",
          solid: true,
        });
      }
      inpAPI.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    onHidden() {
      this.$router.push('/projectManagement');
    },
    consultDocs() {
      this.$root.$emit('bv::show::modal', 'modal-1');
      this.docsCount = '';
      this.modalText = '';
      this.showDocs = '';
    },
    updateIps (ips) {
      const ipv4Regex = /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/g;
      const ipv6Regex = /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/g;
      if (ips.length && !(ips[ips.length-1].match(ipv4Regex) || ips[ips.length-1].match(ipv6Regex))) {
        this.$bvToast.toast("Insira um endereço de IP fixo válido", {
          title: "IP fixo inválido",
          variant: "danger",
          solid: true,
        });
        this.fixedIps = [...this.fixedIps];
        return false;
      }
      this.fixedIps = ips;
      return true;
    },
    formatMoney (m) {
      return m.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    },
  },
};
</script>
